import React, { Component } from 'react';
import ConditionedComponent from 'components/ConditionedComponent.js';
import TrackHowTo from './TrackHowTo.js';
import MetamaskHowTo from './MetamaskHowTo.js';
import UserNameHowTo from './UserNameHowTo.js';
import ethereum from 'decentralized/ethereum.js';

class GettingStarted extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showingMetamask: false,
            showingUserName: false,
            showingTrack: false,
            showingSample: false,
        };

        this.isUserNameChosen();
    }

    toggleMetamask() {
        this.setState({showingMetamask: !this.state.showingMetamask});
    }

    toggleUserName() {
        this.setState({showingUserName: !this.state.showingUserName});
    }

    toggleTrack() {
        this.setState({showingTrack: !this.state.showingTrack});
    }

    toggleSample() {
        this.setState({showingSample: !this.state.showingSample});
    }

    getMetamaskHowTo() {
        return (
            <MetamaskHowTo/>
        );
    }
    
    getUserNameHowTo() {
        return (
            <UserNameHowTo
                onComplete={(user) => this.onCompleteUserName(user)}
              />
        );
    }

    getTrackHowTo() {
        return (
            <TrackHowTo/>
        );
    }

    getSampleHowTo() {
        return (
            <div>Metamask</div>
        );
    }

    isMetamaskInstalled() {
        return ethereum.isMetamaskInstalled();
    }

    async isUserNameChosen() {
        let name = await ethereum.users.getUserName();
        this.setState({userName: name});
    }

    onCompleteUserName(name) {
        console.log('on complete called = ' + name);
        this.setState({userName: name});
    }

    render() {
        return (
            <div className="getting-started">
              <Step
                show={this.state.showingMetamask}
                toggle={() => this.toggleMetamask()}
                isCompleted={this.isMetamaskInstalled()}
                howTo={this.getMetamaskHowTo()}>
                Install Metamask to talk to Ethereum
              </Step>
              <Step
                show={this.state.showingUserName}
                toggle={() => this.toggleUserName()}
                howTo={this.getUserNameHowTo()}
                isCompleted={this.state.userName !== undefined} howTo={this.getUserNameHowTo()}>
                {this.state.userName ?
                    'Choose a username: ' + this.state.userName :
                    'Choose a username'}
              </Step>
              <Step
                show={this.state.showingTrack}
                toggle={() => this.toggleTrack()}
                howTo={this.getTrackHowTo()}>
                Create your first track
              </Step>
              <Step
                show={this.state.showingSound}
                toggle={() => this.toggleSound()}
                howTo={this.getSampleHowTo()}>
                Sample your first sound
              </Step>
            </div>
        );
    }
}

class Step extends Component {
    render() {
        let className = "onboarding-step";
        if (this.props.show) {
            className += ' showing-how-to';
        }

        return (
            <div
              onClick={this.props.toggle}
              className={className}>
              <div className="step-checkmark">
                <ConditionedComponent condition={this.props.isCompleted}>
                  <span className="checkmark">
                    <div className="checkmark_stem"></div>
                    <div className="checkmark_kick"></div>
                  </span>
                </ConditionedComponent>
              </div>
              <div className="step-info">
                <ConditionedComponent condition={!this.props.show}>
                  {this.props.children}
                </ConditionedComponent>
                <ConditionedComponent condition={this.props.show}>
                  <div className="how-to">
                    {this.props.howTo}
                  </div>
                </ConditionedComponent>
              </div>
            </div>
        );
    }
}

export default GettingStarted;
